(() => {
  // Test identifier
  const testId = "DLT-002";

  // 1 · grab the native CTA block and buttons -----------------------
  const nativeWrap   = document.querySelector(
    ".product__main__content .product__block__buttons"
  );
  const nativeATC    = nativeWrap?.querySelector("button.btn--add-to-cart");
  const nativeBuyNow = nativeWrap?.querySelector(
    "button.shopify-payment-button__button"
  );
  if (!nativeATC || !nativeBuyNow) return; // safety-out if markup changes

  // 2 · build the sticky-bar markup and keep it hidden by default ----
  document.body.insertAdjacentHTML(
    "beforeend",
    `
      <div class="${testId}-sticky-buttons" aria-hidden="true">
        <button class="${testId}-sticky-buttons-add-to-cart">
          ${nativeATC.innerHTML}
        </button>
        <button class="${testId}-sticky-buttons-buy-now">
          ${nativeBuyNow.innerHTML}
        </button>
      </div>
    `
  );

  // 3 · wire sticky clicks back to the real buttons -----------------
  const stickyBar = document.querySelector(`.${testId}-sticky-buttons`);
  stickyBar.querySelector(`.${testId}-sticky-buttons-add-to-cart`)
           .addEventListener("click", () => nativeATC.click());
  stickyBar.querySelector(`.${testId}-sticky-buttons-buy-now`)
           .addEventListener("click", () => nativeBuyNow.click());

 /* 4 · show / hide only on mobile --------------------------------- */
const mobileMQ = window.matchMedia("(max-width: 824px)");

function handleVisibility() {
  // If we're *not* on mobile, keep sticky visible and bail out
  if (!mobileMQ.matches) {
    stickyBar.setAttribute("aria-hidden", "false");
    return;
  }

  // Mobile: observe the native button wrap
  const io = new IntersectionObserver(
    ([entry]) => {
      const offScreen = !entry.isIntersecting;
      stickyBar.setAttribute("aria-hidden", offScreen ? "false" : "true");
    },
    { rootMargin: "0px", threshold: 0 }
  );
  io.observe(nativeWrap);
}

handleVisibility();              // run on load
mobileMQ.addEventListener("change", handleVisibility); // re-run if user resizes

})();
